import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
import(/* webpackMode: "eager" */ "/app/node_modules/katex/dist/katex.min.css");
import(/* webpackMode: "eager" */ "/app/node_modules/normalize.css/normalize.css")